export const enum RouteTypesEnum {
	REGISTERED = 'registered',
	UNREGISTERED = 'unregistered',
}
